import { Alert } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import './vacation-info-box.scss';

interface VacationInfoBoxProps {
  infoOption: "CHECKOUT_NOT_ALLOWED" | "PRE_ORDER";
  type: 'info' | 'warning' | 'error';
}

const VacationInfoBox = ({ infoOption, type }: VacationInfoBoxProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { t } = useTranslation()
  const [showIcon, setShowIcon] = useState(true)
  const infoText = infoOption === 'CHECKOUT_NOT_ALLOWED' ?
    t('txt.vacationInfoCheckoutNotAllowed') :
    t('txt.vacationInfoPreOrder') 

  // do not show icon if width too low
  const updateShowIcon = () => {
    const divWidth = containerRef?.current?.offsetWidth || 0
    if (divWidth < 200) {
      setShowIcon(false)
    } else {
      setShowIcon(true)
    }
  }

  useEffect(() => {
    updateShowIcon()
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateShowIcon)

    return () => {
      window.removeEventListener('resize', updateShowIcon)
    }
  }, [])

  return (
    <div className="vacation-info" ref={containerRef}>
      <Alert type={type} message="" description={infoText} showIcon={showIcon}/>
    </div>
  )
}

export default VacationInfoBox